var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Chip, Loader, ChipAction, Menu } from '@pocketlaw/tetris';
export function ChipDropdown(props) {
    const { label, secondary, children, appearance = 'secondary', size = 'large', loading = false, action, open, initiallyOpen = false, onClose, onOpen, side, align } = props, rest = __rest(props, ["label", "secondary", "children", "appearance", "size", "loading", "action", "open", "initiallyOpen", "onClose", "onOpen", "side", "align"]);
    const handleClick = () => {
        if (open) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        else {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
    };
    return (<Menu.Root open={open} onClose={onClose} defaultOpen={initiallyOpen} side={side} align={align} target={<Chip appearance={appearance} size={size} label={label} secondary={secondary} onClick={handleClick} action={loading ? (<ChipAction type="button">
                <Loader />
              </ChipAction>) : (action)} {...rest}/>}>
      {children}
    </Menu.Root>);
}
ChipDropdown.displayName = 'ChipDropdown';
